import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FormDashboardLabel as Label, Table, User } from '../../../components'
import { fetchIndividu } from '../../../features/individu/slice'
import { fetchJoinRequests } from '../../../features/join-requests/slice'

const JoinRequests = () => {
  const dispatch = useDispatch()
  const status = useSelector(state => state.joinRequests.status)
  const statusIndividu = useSelector(state => state.individu.status)
  const id = useSelector(state => state.account.profile.userId)
  const joinRequests = useSelector(state => state.joinRequests.data)

  React.useEffect(() => {
    if(status === 'idle'){
      dispatch(fetchJoinRequests())
    }
  }, [dispatch, status])

  React.useEffect(() => {
    if(statusIndividu === 'idle'){
      dispatch(fetchIndividu(id))
    }
  }, [dispatch, statusIndividu, id])

  const tableData = useMemo(() => joinRequests, [joinRequests])
  const tableColumns = useMemo(
    () => [
      {
        Header: 'To',
        accessor: 'sender.name',
        Cell: (props) => {
          const id = props.data[props.row.index].sender.id
          return (
            <Link to={`/organization/${id}`}>
              <User small name={props.value} />
            </Link>
          )
        }
      },
      {
        Header: 'Status',
        accessor: 'status.name',
      }
    ],
    []
  )

  return (joinRequests && joinRequests.length > 0) ? (
    <div className="lg:border lg:rounded lg:p-4 mt-5 lg:mt-8">
      <Label>Join Requests</Label>

      <Table
        data={tableData}
        columns={tableColumns}
      />
    </div>
  ) : (<></>)
}

export { JoinRequests }
